module.exports = __webpack_public_path__ + "img/step-4-2-en.0d2ced27.png";